/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { QuestConfigMilestone } from './QuestConfigMilestone';
import {
    QuestConfigMilestoneFromJSON,
    QuestConfigMilestoneFromJSONTyped,
    QuestConfigMilestoneToJSON,
    QuestConfigMilestoneToJSONTyped,
} from './QuestConfigMilestone';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface QuestConfig
 */
export interface QuestConfig {
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    updatedAt: number;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfig
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * Display quest to users who have not yet met prerequisites.
     * @type {boolean}
     * @memberof QuestConfig
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfig
     */
    requireProgressionOrder?: boolean;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof QuestConfig
     */
    name: string;
    /**
     * Kicker rendered above the segment name on the journey map masthead (e.g. "Get in the Game" over Boot Camp).
     * @type {string}
     * @memberof QuestConfig
     */
    groupLabel?: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof QuestConfig
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof QuestConfig
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof QuestConfig
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof QuestConfig
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfig
     */
    questReset: QuestReset;
    /**
     * 
     * @type {Array<QuestConfigMilestone>}
     * @memberof QuestConfig
     */
    milestones?: Array<QuestConfigMilestone>;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof QuestConfig
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfig
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof QuestConfig
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Quest-level catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof QuestConfig
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * Per-reward auto-claim settings for quest-level rewards. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestConfig
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfig
     */
    linkedQuestConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfig
     */
    partnerServiceIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfig
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    rewardImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    backgroundImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    endAt?: number;
    /**
     * Per-user relative completion window in days (unset = open-ended).
     * @type {number}
     * @memberof QuestConfig
     */
    completionWindowDays?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    maxUserCompletions?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    currentUserCompletions?: number;
    /**
     * Cheat-filtering match-bracketing gate — when true, this quest only progresses while the user has an active Match Start or Round Start in Redis
     * @type {boolean}
     * @memberof QuestConfig
     */
    requireActiveMatch?: boolean;
}



/**
 * Check if a given object implements the QuestConfig interface.
 */
export function instanceOfQuestConfig(value: object): value is QuestConfig {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('questReset' in value) || value['questReset'] === undefined) return false;
    return true;
}

export function QuestConfigFromJSON(json: any): QuestConfig {
    return QuestConfigFromJSONTyped(json, false);
}

export function QuestConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'displayedOn': json['displayedOn'] == null ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': json['shouldDisplayUnqualified'] == null ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': json['requireProgressionOrder'] == null ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'groupLabel': json['groupLabel'] == null ? undefined : json['groupLabel'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'questReset': QuestResetFromJSON(json['questReset']),
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(QuestConfigMilestoneFromJSON)),
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'linkedQuestConfigIds': json['linkedQuestConfigIds'] == null ? undefined : json['linkedQuestConfigIds'],
        'partnerServiceIds': json['partnerServiceIds'] == null ? undefined : json['partnerServiceIds'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'backgroundImage': json['backgroundImage'] == null ? undefined : json['backgroundImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'completionWindowDays': json['completionWindowDays'] == null ? undefined : json['completionWindowDays'],
        'maxUserCompletions': json['maxUserCompletions'] == null ? undefined : json['maxUserCompletions'],
        'currentUserCompletions': json['currentUserCompletions'] == null ? undefined : json['currentUserCompletions'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
    };
}

export function QuestConfigToJSON(json: any): QuestConfig {
    return QuestConfigToJSONTyped(json, false);
}

export function QuestConfigToJSONTyped(value?: QuestConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'displayedOn': value['displayedOn'] == null ? undefined : ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value['shouldDisplayUnqualified'],
        'requireProgressionOrder': value['requireProgressionOrder'],
        'name': value['name'],
        'groupLabel': value['groupLabel'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'questReset': QuestResetToJSON(value['questReset']),
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(QuestConfigMilestoneToJSON)),
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'rewardAutoSettings': value['rewardAutoSettings'],
        'linkedQuestConfigIds': value['linkedQuestConfigIds'],
        'partnerServiceIds': value['partnerServiceIds'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'backgroundImage': value['backgroundImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'completionWindowDays': value['completionWindowDays'],
        'maxUserCompletions': value['maxUserCompletions'],
        'currentUserCompletions': value['currentUserCompletions'],
        'requireActiveMatch': value['requireActiveMatch'],
    };
}

